import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
import styles from "./CreditBanner.module.scss";
import classNames from "classnames";
import { useFeatureFlags } from "@~/flags/flags";

export type CreditBannerType = "IFC" | "IBC" | "IFC-IBC" | null;

export const CreditBanner = ({
  creditBannerType,
  className,
}: {
  creditBannerType: CreditBannerType;
  className?: string;
}) => {
  const { newCreditTextEnabled } = useFeatureFlags();
  const isNewCreditTextEnabled = Boolean(newCreditTextEnabled?.value);
  const bannerContent = isNewCreditTextEnabled
    ? {
        IFC: {
          title: "*Payment plans at John Lewis",
          body: (
            <>
              Credit options are available on selected products. See the product
              page for details.
              <br />
              <br />
              Credit subject to status. UK 18+. John Lewis plc is an appointed
              representative of John Lewis Finance Limited, who is a credit
              broker. Creation Consumer Finance Limited is the Lender. T&Cs
              apply.{" "}
              <a href="https://www.johnlewis.com/our-services/paymentplans">
                Find out more
              </a>
            </>
          ),
        },
        IBC: {
          title: "*Payment plans at John Lewis",
          body: (
            <>
              More time to pay Representative Example (24.9% APR): If product
              price £1,000.00 and your loan period is 3 years at 24.9% APR
              Representative (fixed), you would pay 36 monthly repayments of
              £38.41, totalling £1,382.76. This includes £382.76 in interest.
              <br />
              <br />
              Credit options are available on selected products. See the product
              page for details.
              <br />
              <br />
              Credit subject to status. UK 18+. John Lewis plc is an appointed
              representative of John Lewis Finance Limited, who is a credit
              broker. Creation Consumer Finance Limited is the Lender. T&Cs
              apply.{" "}
              <a href="https://www.johnlewis.com/our-services/paymentplans">
                Find out more
              </a>
            </>
          ),
        },
        "IFC-IBC": {
          title: "*Payment plans at John Lewis",
          body: (
            <>
              More time to pay Representative Example (24.9% APR): If product
              price £1,000.00 and your loan period is 3 years at 24.9% APR
              Representative (fixed), you would pay 36 monthly repayments of
              £38.41, totalling £1,382.76. This includes £382.76 in interest.
              <br />
              <br />
              Pay no interest and Buy Now, Pay Later (29.9% APR) options are
              available on selected products. See the product page for details.
              <br />
              <br />
              Credit subject to status. UK 18+. John Lewis plc is an appointed
              representative of John Lewis Finance Limited, who is a credit
              broker. Creation Consumer Finance Limited is the Lender. T&Cs
              apply.{" "}
              <a href="https://www.johnlewis.com/our-services/paymentplans">
                Find out more
              </a>
            </>
          ),
        },
      }
    : {
        IFC: {
          title: "*Interest free credit",
          body: (
            <>
              Credit subject to status. UK 18+. John Lewis plc is an appointed
              representative of John Lewis Finance Limited, who is a credit
              broker. Creation Consumer Finance Limited is the Lender. T&Cs
              apply.
            </>
          ),
        },
        IBC: {
          title: "*Interest bearing credit",
          body: (
            <>
              Representative example for 24.9% APR: If product price £1,000.00
              and your loan period is 3 years at 24.9% APR, you would pay 36
              monthly repayments of £38.41, totalling £1,382.76. This includes
              £382.76 in interest.
              <br />
              Credit subject to status. UK 18+. John Lewis plc is an appointed
              representative of John Lewis Finance Limited, who is a credit
              broker. Creation Consumer Finance Limited is the Lender. T&Cs
              apply.
            </>
          ),
        },
        "IFC-IBC": {
          title: "*Interest bearing credit",
          body: (
            <>
              Representative example for 24.9% APR: If product price £1,000.00
              and your loan period is 3 years at 24.9% APR, you would pay 36
              monthly repayments of £38.41, totalling £1,382.76. This includes
              £382.76 in interest.
              <br />
              Interest free and other payment plans are available on selected
              products.
              <br />
              For 0% and 24.9% APR credit subject to status. UK 18+. John Lewis
              plc is an appointed representative of John Lewis Finance Limited,
              who is a credit broker. Creation Consumer Finance Limited is the
              Lender. T&Cs apply.
            </>
          ),
        },
      };

  return (
    creditBannerType && (
      <figure
        data-test-type={creditBannerType}
        data-component="CreditBanner"
        data-testid="credit-banner"
        className={classNames(className, styles.container)}
      >
        <Message
          {...bannerContent[creditBannerType]}
          whiteBackground
          type="information"
        />
      </figure>
    )
  );
};
